/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Breakdown/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PayerInfo from './PayerInfo/index'
import React from 'react'
import Treatment from './Treatment/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'



/** @type {import('Simple/types.js').View} */
export default function Breakdown({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/CreateTreatmentPlan/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let payersPayersValueData = fromData.useDataValue({ viewPath,
context: 'payers',
path: 'payers',
})
  return (<React.Fragment
>
<Treatment
  viewPath={`${viewPath}/Treatment`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={dtSpaceM}
 marginTop={0}
 backgroundColor={dtColorsNeutral300}
/>
<div
  data-testid="Breakdown.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(payersPayersValueData) && payersPayersValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="payer"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/PayerInfo(${item?.id ?? item?._id ?? index})`}
      >
<PayerInfo
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/PayerInfo(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }